import { ResponsiveImage } from '@sleepstation/components'
import { Copy } from '@sleepstation/components-copy'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_SPACING } from '@sleepstation/const'
import { mq } from '@sleepstation/style-api-helpers'
import { rem } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: LAYOUT_SPACING.LARGE,
})``

const ImageWrapper = styled.div`
  align-self: center;
  flex-grow: 1;
  width: 100%;

  > * {
    display: block;
    margin: 0 auto;
    width: 100%;
    ${mq(`mediumUp`)} {
      max-width: ${rem(525)};
    }
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const SimpleImageAndTitle = ({ TitleComponent, image, title, children }) => (
  <Layout>
    <ImageWrapper>
      <ResponsiveImage src={image.url} alt={image.alt} />
    </ImageWrapper>
    <TitleComponent>{title}</TitleComponent>
    <Copy>{children}</Copy>
  </Layout>
)

SimpleImageAndTitle.propTypes = {
  image: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  TitleComponent: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
}

export default SimpleImageAndTitle
